import React from "react";
import { ShieldAlert, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth-context";

/**
 * ImpersonationBanner — sticky red banner shown at the top of every page
 * whenever the current session is an impersonated one. The banner is the
 * ONLY exit path back to the original admin session.
 */
export default function ImpersonationBanner() {
    const { user } = useAuth();
    const imp = user?.impersonated_by;
    if (!imp) return null;

    const exit = () => {
        const origToken = localStorage.getItem("analyzio_orig_token");
        const origUser = localStorage.getItem("analyzio_orig_user");
        if (!origToken || !origUser) {
            toast.error("Couldn't find original session — please sign in again.");
            localStorage.removeItem("analyzio_token");
            localStorage.removeItem("analyzio_user");
            window.location.assign("/login");
            return;
        }
        localStorage.setItem("analyzio_token", origToken);
        localStorage.setItem("analyzio_user", origUser);
        localStorage.removeItem("analyzio_orig_token");
        localStorage.removeItem("analyzio_orig_user");
        toast.success("Exited impersonation");
        window.location.assign("/users");
    };

    return (
        <div className="sticky top-0 z-40 flex items-center justify-between gap-3 px-4 py-2 bg-destructive text-destructive-foreground text-sm font-medium border-b border-destructive/50" data-testid="impersonation-banner">
            <div className="flex items-center gap-2 min-w-0">
                <ShieldAlert className="h-4 w-4 shrink-0" />
                <span className="truncate">
                    Impersonating <span className="font-mono">{user.email}</span> · every action is logged and attributed to <span className="font-mono">{imp.email}</span>
                </span>
            </div>
            <button
                onClick={exit}
                className="inline-flex items-center gap-1 rounded-sm bg-white/15 hover:bg-white/25 px-3 py-1 text-xs uppercase tracking-wider font-mono transition-colors shrink-0"
                data-testid="impersonation-exit">
                <LogOut className="h-3 w-3" /> Exit
            </button>
        </div>
    );
}
